module.exports = flarum.core.compat['components/LogInModal'];